<template>
    <div class="bash-wrap" id="customer-case" name="customer-case":style="'background:url(' + indata.bgcImage + ') no-repeat 50% 50%;'">
            <div class="bash-box customer-case-box">
                <p class="h1">{{ indata.FirstTitle }}</p>
                <ul class="case-ul">
                    <li v-for="(item, index) in indata.children":key="index" >
                        <span>
                            <i class="huixingzhen"  :style="'background:url('+item.image+') no-repeat 50% 50%'"></i>
                            </span>
                        <p class="h2">{{ item.title}}</p>
                        <p class="detail">{{item.produce}}</p>
                        <!-- <div class="case-hover-box">
                            <p class="result-title">实施效果</p>
                            <p class="result">实施软件后，线上店铺的库存可自动同步，精确统计库存增减，数据随时清晰可查；系统自动分类、汇总、统计并生成各项业务财务报表，和供应商、往来客户的每一笔往来账期都清晰可查。</p>
                        </div> -->
                    </li>
                 
                </ul>
            </div>
        </div>
</template>

<style scoped src="../../public/css/erp.css">

</style>
<script>
export default {
  name: "Templates15",
  props: {
    indata: Array,
  },
  computed: {
  //这里设置banner 是在900像素下高度为200px，我的banner图格式为1920X900像素
    autoHeight() {
      let _w =
        document.documentElement.clientWidth || document.body.clientWidth;
      return (_w * 200) / 450 + "px";
    }
  },
  data() {
    return {
      NowIndex: 0,
    };
  },
  methods: {
    changeActive(index) {
      this.NowIndex = index;
    },
  },
};
</script>
